import { addDays, startOfToday } from 'date-fns/esm'
import type { ScheduleMode } from './typings'

export const initialStartDate = startOfToday()
export const initialEndDate = addDays(startOfToday(), 3)

export function modeToDrawerTitle(mode?: ScheduleMode): string {
  switch (mode) {
    case 'free':
      return 'Schedule Free Estimate'
    case 'paid':
      return 'Schedule Paid Estimate'
    case 'service':
      return 'Schedule Service'
    default:
      return ''
  }
}

export function modeToButtonLabel(
  mode: ScheduleMode,
  required?: boolean,
): string {
  const req = required ? ' - Required to Close Win*' : ''

  let label = ''

  switch (mode) {
    case 'free':
      label = 'Free Estimate'
      break
    case 'paid':
      label = 'Paid Estimate'
      break
    case 'service':
      label = 'Service'
      break
  }

  return `${label}${req}`
}
